module.exports = __webpack_public_path__ + "static/media/lettuce.b157b9dc.jpg";